<template>
  <div>
    <h1>Seiten</h1>
    <h2 v-if="selectedItem">Bearbeiten: {{ selectedItem.name }}</h2>

    <LoadingSpinner v-if="isLoading"></LoadingSpinner>
    <template v-else>
      <template v-if="!selectedItem">
        <table v-if="items && items.length > 0" style="max-width: 100%;">
          <tr>
            <th>Name</th>
            <th>Aktionen</th>
          </tr>
          <tr v-for="item in items">
            <td>
              {{ item.name }}
            </td>
            <td>
              <button @click="selectedItem = item">Bearbeiten</button>
            </td>
          </tr>
        </table>
        <template v-else>
          Keine Daten gefunden
        </template>
      </template>
      <template v-else>
        <div class="edit-form">
          <label>
            Text<br />
            <span class="note">
              <a href="https://de.wikipedia.org/wiki/Markdown" target="_blank">(Markdown-Syntax)</a>
            </span>
          </label>
          <textarea v-model="selectedItem.content" />
        </div>

        <button @click="saveItem">Speichern</button>
        <button @click="selectedItem = null">Abbrechen</button>
      </template>
    </template>
  </div>
</template>

<script>
  import LoadingSpinner from '../../parts/LoadingSpinner'
  import rest from '../../../services/rest'
  import Vue from 'vue'

  export default {
    name: 'AdminPages',
    components: {
      LoadingSpinner
    },
    data () {
      return {
        isLoadingItems: true,
        items: [],
        selectedItem: null
      }
    },
    computed: {
      isLoading () {
        return this.isLoadingItems
      }
    },
    methods: {
      loadItems () {
        this.isLoadingItems = true
        rest.pages.all((response, hasError) => {
          if (hasError) { return }
          this.items = response.body
          this.isLoadingItems = false
        })
      },
      saveItem () {
        this.isLoadingItems = true
        // Update
        rest.pages.update(this.selectedItem, (response, hasError) => {
          if (hasError) {
            this.isLoadingItems = false
            return
          }
          let newItem = response.body
          let index = this.items.indexOf(this.selectedItem)
          Vue.set(this.items, index, newItem)
          this.selectedItem = null
          this.isLoadingItems = false
        })
      }
    },
    mounted () {
      this.loadItems()
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// AdminPages.vue?3de6f66c